import { useTheme } from '@mui/material';
import {
  CustomRadioInput,
  CustomSelect,
  Heading4,
  TextL,
} from 'app/components';
import { ReviewStepBox, SignTypeContainer } from '../../styles';
import { SignatureProvider } from '../../../../interfaces';
import {
  SignatureAuthenticationMode,
  SignatureUnicoAuthenticationMode,
} from 'modules/products/services/api/applicationsHttpService';

interface SignatureOption {
  value: SignatureAuthenticationMode;
  label: string;
}

interface SignatureUnicoOption {
  value: SignatureUnicoAuthenticationMode;
  label: string;
}

interface SignatureProviderOption {
  value: string;
  label: string;
}

interface ReviewStepSignatureProps {
  availableSignatureProviders: SignatureProviderOption[];
  selectedSignatureProvider: string | undefined;
  setSelectedSignatureProvider: (value: string) => void;
  signatureMethod: SignatureAuthenticationMode;
  updateSignatureMethod: (value: SignatureAuthenticationMode) => void;
  signatureMethodUnico: SignatureUnicoAuthenticationMode;
  setSignatureMethodUnico: (value: SignatureUnicoAuthenticationMode) => void;
  selectedSignatureType: string;
  handleSelectSignatureType: (value: string) => void;
  signatureOptions: SignatureOption[];
  signatureUnicoOptions: SignatureUnicoOption[];
}

const ReviewStepSignature = ({
  availableSignatureProviders,
  selectedSignatureProvider,
  setSelectedSignatureProvider,
  signatureMethod,
  updateSignatureMethod,
  signatureMethodUnico,
  setSignatureMethodUnico,
  selectedSignatureType,
  handleSelectSignatureType,
  signatureOptions,
  signatureUnicoOptions,
}: ReviewStepSignatureProps) => {
  const theme = useTheme();

  return (
    <>
      <ReviewStepBox marginTop="16px" marginBottom="16px">
        <SignTypeContainer>
          <Heading4 style={{ color: theme.palette.brand.secondary.base }}>
            Provedor de assinatura:{' '}
          </Heading4>
          <div className="bullet-area">
            {availableSignatureProviders.map((provider) => (
              <div key={provider.value} className="bullet-item">
                <CustomRadioInput
                  isChecked={selectedSignatureProvider === provider.value}
                  handleClick={() =>
                    setSelectedSignatureProvider(provider.value)
                  }
                />
                <TextL>{provider.label}</TextL>
              </div>
            ))}
          </div>
        </SignTypeContainer>
        {selectedSignatureProvider === SignatureProvider.CLICKSIGN && (
          <SignTypeContainer style={{ marginTop: '2rem' }}>
            <TextL
              style={{
                color: theme.palette.brand.secondary.base,
              }}
            >
              Método de assinatura:{' '}
            </TextL>
            <div>
              <CustomSelect
                styles={{
                  width: '350px',
                }}
                value={signatureOptions.find(
                  (opt) => opt.value === signatureMethod,
                )}
                options={signatureOptions}
                handleInputChange={(evt) => {
                  updateSignatureMethod(evt.currentTarget.value?.value);
                }}
                name="signatureMethod"
                placeholder="Selecionar"
                isClearable={false}
              />
            </div>
          </SignTypeContainer>
        )}
        {selectedSignatureProvider === SignatureProvider.UNICO && (
          <SignTypeContainer style={{ marginTop: '2rem' }}>
            <TextL
              style={{
                color: theme.palette.brand.secondary.base,
              }}
            >
              Método de assinatura:{' '}
            </TextL>
            <div>
              <CustomSelect
                styles={{
                  width: '350px',
                }}
                value={signatureUnicoOptions.find(
                  (opt) => opt.value === signatureMethodUnico,
                )}
                options={signatureUnicoOptions}
                handleInputChange={(evt) => {
                  setSignatureMethodUnico(evt.currentTarget.value?.value);
                }}
                name="signatureMethod"
                placeholder="Selecionar"
                isClearable={false}
              />
            </div>
          </SignTypeContainer>
        )}
      </ReviewStepBox>
      <ReviewStepBox marginTop="16px" marginBottom="32px">
        <SignTypeContainer>
          <Heading4 style={{ color: theme.palette.brand.secondary.base }}>
            Receber assinatura por:{' '}
          </Heading4>
          <div className="bullet-area">
            <div className="bullet-item">
              <CustomRadioInput
                isChecked={selectedSignatureType === 'WHATSAPP'}
                handleClick={() => handleSelectSignatureType('WHATSAPP')}
              />
              <TextL>WhatsApp</TextL>
            </div>
            <div className="bullet-item">
              <CustomRadioInput
                isChecked={
                  selectedSignatureProvider === SignatureProvider.UNICO
                    ? selectedSignatureType === 'SMS'
                    : selectedSignatureType === 'EMAIL'
                }
                handleClick={() =>
                  handleSelectSignatureType(
                    selectedSignatureProvider === SignatureProvider.UNICO
                      ? 'SMS'
                      : 'EMAIL',
                  )
                }
              />
              <TextL>
                {selectedSignatureProvider === SignatureProvider.UNICO
                  ? 'SMS'
                  : 'E-mail'}
              </TextL>
            </div>
            <div className="bullet-item">
              <CustomRadioInput
                isChecked={selectedSignatureType === 'LINK'}
                handleClick={() => handleSelectSignatureType('LINK')}
              />
              <TextL>Link</TextL>
            </div>
          </div>
        </SignTypeContainer>
      </ReviewStepBox>
    </>
  );
};

export default ReviewStepSignature;
